import { render, staticRenderFns } from "./DashboardSectionWrapper.vue?vue&type=template&id=212c9073&"
import script from "./DashboardSectionWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardSectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSectionWrapper.vue?vue&type=style&index=0&id=212c9073&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports